	<script lang="ts">
	import { RadioButtonSingle, Select, Tooltip } from '@cf/ui-lib';
	import { BrandStatusEnum, BrandStatuses, getBrandStatusDisplay } from '@cf/ui-lib/typings';
	import { onMount } from 'svelte';

	export let status: BrandStatusEnum = BrandStatusEnum.Locked;
	export let id = '';
	export let onStatusChange = (status: string, id: string) => {};

	let className = 'border-[#FFB900] bg-[#FFF8E6]';
	$: {
		if (status?.toLocaleUpperCase() === BrandStatusEnum.Approved) {
			className = 'border-[#32DFA7] bg-[#EBFCF6]';
		} else if (status?.toLocaleUpperCase() === BrandStatusEnum.Locked) {
			className = 'border-[#6C757D] bg-[#F0F1F2]';
		} else if (status?.toLocaleUpperCase() === BrandStatusEnum.Suspect) {
			className = 'border-[#F95353] bg-[#FEEEEE]';
		}
	}

	let brandstatus = BrandStatuses.find((item) => item.value == status?.toLocaleUpperCase())
		?.label as BrandStatusEnum;

	const statusChange = ({ detail: { value } }: CustomEvent<{ value: BrandStatusEnum }>) => {
		status = value;
		onStatusChange(status, id);
	};
</script>

<Tooltip {id} idData="status" toggleClass="-mr-20" isCloseOnOutsideClick={true}>
	<ul class="grid list-none gap-[20px]" slot="tooltip-list">
		<li class="flex w-full items-center gap-[10px]">
			<div class="flex w-full">
				<RadioButtonSingle
					label={getBrandStatusDisplay(BrandStatusEnum.Approved)}
					name="status"
					selectedOption={status}
					value={BrandStatusEnum.Approved}
					on:change={statusChange}
					lableClass="group border border-solid rounded px-3 py-2 w-full text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#32DFA7] bg-[#EBFCF6]"
				/>
			</div>
		</li>
		<li class="flex w-full items-center gap-[10px]">
			<div class="flex w-full">
				<RadioButtonSingle
					label={getBrandStatusDisplay(BrandStatusEnum.Undetermined)}
					name="status"
					selectedOption={status}
					value={BrandStatusEnum.Undetermined}
					on:change={statusChange}
					lableClass="group border border-solid rounded px-3 py-2 w-full text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#FFB900] bg-[#FFF8E6]"
				/>
			</div>
		</li>
		<!-- <li class="flex w-full items-center gap-[10px]">
			<div class="flex w-full">
				<RadioButtonSingle
					label="Ignore"
					name="status"
					selectedOption={status}
					value={BrandStatusEnum.Locked}
					on:change={statusChange}
					lableClass="group border border-solid rounded px-3 py-2 w-[107px] text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#6C757D] bg-[#F0F1F2]"
				/>
			</div>
		</li> -->
		<li class="flex w-full items-center gap-[10px]">
			<div class="flex w-full">
				<RadioButtonSingle
					label={getBrandStatusDisplay(BrandStatusEnum.Suspect)}
					name="status"
					selectedOption={status}
					value={BrandStatusEnum.Suspect}
					on:change={statusChange}
					lableClass="group border border-solid rounded px-3 py-2 w-full text-xs font-semibold leading-[15px] font-inter text-dark text-center border-[#F95353] bg-[#FEEEEE]"
				/>
			</div>
		</li>
	</ul>
	<div class="flex w-full" slot="button-details">
		<div
			class="group w-[127px] rounded border border-solid px-3 py-2 text-center font-inter text-xs font-semibold leading-[15px] text-dark {className}"
		>
			{#if BrandStatuses.find((item) => item.value == status?.toLocaleUpperCase())?.label == BrandStatusEnum.NeedsReview}
				{getBrandStatusDisplay(BrandStatusEnum.Undetermined)}
			{:else}
				{getBrandStatusDisplay(brandstatus)}
			{/if}
		</div>
	</div>
</Tooltip>
